function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "COM-4258",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "help_outline_black"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 32 0 32 32 0 32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6666667,24 L17.3333333,24 L17.3333333,21.3333333 L14.6666667,21.3333333 L14.6666667,24 Z M16,2.66666667 C8.64,2.66666667 2.66666667,8.64 2.66666667,16 C2.66666667,23.36 8.64,29.3333333 16,29.3333333 C23.36,29.3333333 29.3333333,23.36 29.3333333,16 C29.3333333,8.64 23.36,2.66666667 16,2.66666667 Z M16,26.6666667 C10.12,26.6666667 5.33333333,21.88 5.33333333,16 C5.33333333,10.12 10.12,5.33333333 16,5.33333333 C21.88,5.33333333 26.6666667,10.12 26.6666667,16 C26.6666667,21.88 21.88,26.6666667 16,26.6666667 Z M16,8 C13.0533333,8 10.6666667,10.3866667 10.6666667,13.3333333 L13.3333333,13.3333333 C13.3333333,11.8666667 14.5333333,10.6666667 16,10.6666667 C17.4666667,10.6666667 18.6666667,11.8666667 18.6666667,13.3333333 C18.6666667,16 14.6666667,15.6666667 14.6666667,20 L17.3333333,20 C17.3333333,17 21.3333333,16.6666667 21.3333333,13.3333333 C21.3333333,10.3866667 18.9466667,8 16,8 Z",
  id: "Shape",
  fill: "#FBCC0F",
  fillRule: "nonzero"
})));

function SvgHelpOutlineBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "help_outline_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutlineBlack);
export default __webpack_public_path__ + "static/media/help_outline_black.498f2638.svg";
export { ForwardRef as ReactComponent };